import React, { useEffect, useReducer, useState, createContext, useCallback } from "react";
import { setCurrentHomePage, setCurrentHomePageBeforeNotificationTab, setExternalSignIn, setGoHome, setLoader } from "../../action/homeAction";
import { closeOrderPopUp } from "../../action/hCommerce2";
import { sendAnalytics } from "../../../action/homeAction";
import { withTranslation } from "react-i18next";
import { CMSPath } from "../../../config/constant";
import { connect } from "react-redux";
import { currentWidget, popupOpenClose, setShowAutoLoginPopup, setShowCustomPopup } from "../../../action/action";
import LandingPage from "./LandingPage";
import SettingPage from "./SettingPage";
import MyStayPage from "./MyStayPage";
import { getTheKnowLoginUrl, getVredAccessToken, getVredStayData, updateLinkedAccountInfo } from "../../../action/the_know";
import { inAppBrowser } from '../../JS/inAppBrowser'
import LoaderPage from "./LoaderPage";
import PointsPage from "./PointsPage";
import { myTripsKeys, theKnowKeys } from "../../../config/layout2constant";
import { setCurrentTabNavItemList } from "../../action/action";
import { stayReservationPossibleStatus, userAutoLoginUsingTheKnow } from "./helper";
import { getDefaultAnalyticsLabel } from "../../JS/utility";

export const MyContext = createContext();

const IPossiblePages = {
    LANDING_PAGE: 'LANDING_PAGE',
    SETTING_PAGE: 'SETTING_PAGE',
    MY_STAY_PAGE: 'MY_STAY_PAGE',
    LOADER_PAGE: 'LOADER_PAGE',
    POINTS_PAGE: "POINTS_PAGE"
}


const IApiData = {
    POINTS_ENABLE_FETCHING: "POINTS_ENABLE_FETCHING",
    POINTS_DATA_SUCCESS: "POINTS_DATA_SUCCESS",
    POINTS_DATA_FAILURE: "POINTS_DATA_FAILURE",

    STAYS_ENABLE_FETCHING: "STAYS_ENABLE_FETCHING",
    STAYS_DATA_SUCCESS: "STAYS_DATA_SUCCESS",
    STAYS_DATA_FAILURE: "STAYS_DATA_FAILURE",
    STAYS_DATA_INIT: "STAYS_DATA_INIT",

    URLS_ENABLE_FETCHING: "URLS_ENABLE_FETCHING",
    URLS_DATA_SUCCESS: "URLS_DATA_SUCCESS",
    URLS_DATA_FAILURE: "URLS_DATA_FAILURE"

}

export const TheKnowResponseCodeFromHostedScriptForInAppBrowser ={
    VALIDATE_API_FAIL:"VALIDATE_API_FAIL",
    EMPTY_REDIRECT_URI_FOR_VRED:"EMPTY_REDIRECT_URI_FOR_VRED",
    ABORT_TO_CONNECT_VRED:"ABORT_TO_CONNECT_VRED",
    SUCCESSFUL_CONNECTION_TO_VRED:"SUCCESSFUL_CONNECTION_TO_VRED",
    UNSUCCESSFUL_CONNECTION_TO_VRED:"UNSUCCESSFUL_CONNECTION_TO_VRED",
    RECEIVED_CODE_FOR_VRED:"RECEIVED_CODE_FOR_VRED",
    REDIRECTION_URI:"REDIRECTION_URI",
    SUCCESSFUL_LOGOUT_TO_VRED: "SUCCESSFUL_LOGOUT_TO_VRED",
    GOT_MEMBER_ID:"GOT_MEMBER_ID"
}

const apiDataInitState = {
    POINTS: {
        isFetching: false,
        data: null
    },

    STAYS: {
        isFetching: false,
        data: null
    },

    URLS: {
        isFetching: false,
        data: null
    },
}

const apiDataReducer = (state, action) => {
    console.log("apiDataReducer called", action.type)
    switch (action.type) {
        case IApiData.POINTS_ENABLE_FETCHING:
            return { ...state, POINTS: { isFetching: true, data: null } };
        case IApiData.POINTS_DATA_SUCCESS:
            return { ...state, POINTS: { isFetching: false, data: action.payload } };
        case IApiData.POINTS_DATA_FAILURE:
            return { ...state, POINTS: { isFetching: false, data: null, errorMsg: action.payload } };

        case IApiData.STAYS_ENABLE_FETCHING:
            return { ...state, STAYS: { isFetching: true, data: null } };
        case IApiData.STAYS_DATA_SUCCESS:
            return { ...state, STAYS: { isFetching: false, data: action.payload } };
        case IApiData.STAYS_DATA_FAILURE:
            return { ...state, STAYS: { isFetching: false, data: null, errorMsg: action.payload } };
        case IApiData.STAYS_DATA_INIT:
            return { ...state, STAYS: { isFetching: false, data: null } };

        case IApiData.URLS_ENABLE_FETCHING:
            return { ...state, URLS: { isFetching: true, data: null } };
        case IApiData.URLS_DATA_SUCCESS:
            return { ...state, URLS: { isFetching: false, data: action.payload } };
        case IApiData.URLS_DATA_FAILURE:
            return { ...state, URLS: { isFetching: false, data: null, errorMsg: action.payload } };
        default:
            return state;
    }
}

const TheKnow = (props) => {

    const { t } = props;


    const [errorMsg, setErrorMsg] = useState("");
    const [onSsoSuccessUrl, setOnSsoSuccessUrl]=useState("");

    const currentPageReducer = (state, action) => {
        console.log("currentPageReducer called", action.type)
        switch (action.type) {
            case IPossiblePages.LANDING_PAGE:
                return IPossiblePages.LANDING_PAGE;
            case IPossiblePages.SETTING_PAGE:
                return IPossiblePages.SETTING_PAGE;
            case IPossiblePages.MY_STAY_PAGE:
                dispatchApiData({type:IApiData.STAYS_DATA_INIT})
                return IPossiblePages.MY_STAY_PAGE;
            case IPossiblePages.POINTS_PAGE:
                return IPossiblePages.POINTS_PAGE;
            case IPossiblePages.LOADER_PAGE:
                return IPossiblePages.LOADER_PAGE;
            default:
                return state
        }
    }

    const [accessTokenExpired, setAccessTokenExpired] = useState(false);
    const [apiData, dispatchApiData] = useReducer(apiDataReducer, apiDataInitState);
    const [currentPage, dispatchCurrentPage] = useReducer(currentPageReducer, IPossiblePages.LOADER_PAGE); //IPossiblePages.LANDING_PAGE
    const [ssoIABExitClicked, setSsoIABExitClicked] = useState(false);

    const sendTheAnalytics = (taskName, isSuccess, msg) => {
        try {
            props.sendAnalytics(
                props.guestDetail,
                props.currentWidgets && props.currentWidgets.widgetType,
                `${taskName} ${isSuccess ? "Success" : "Failure"}`,
                { "layoutTab": props.currentHomePage && props.currentHomePage.tabName, "element": "widget","pageName":"THE KNOW", errorMessage: msg },
                0,
                props.guestIsLoggedIn
            );
        } catch (error) {
            return error;
        }

    }

    const signOutSSO = (logoutUrl) => {
        //   prod
        //  `https://theknow.virginhotels.com/connect/endsession?post_logout_redirect_uri=https://guest-journey.s3.us-east-1.amazonaws.com/static/virgin/theknow_logout.html&client_id=${THE_KNOW_CLIENT_ID}&id_token_hint=${props.externalSignIn.jwtIdToken}`;
        
        // uat 
        // `https://virginuat.cendyn.com/connect/endsession?post_logout_redirect_uri=https://guest-journey.s3.amazonaws.com/static/cendyn/logout.html&client_id=JES4yd5IHFXzIaexd3nnEiiNQDRu6Kdu&id_token_hint=${props.externalSignIn.jwtIdToken}`;


        let updatedUrl;

        if(logoutUrl) updatedUrl= String(logoutUrl).replace("#ID_TOKEN_HINT",props.externalSignIn.jwtIdToken);

        console.log("updatedUrl",updatedUrl)
        inAppBrowser(updatedUrl || "", props, true, { displayName: "", dontSetCurrentWidget: true, meta: { loadInExternalBrowser: false } });
        
        handleSignOut();
    }

    const handleGoBack = () => {

        if (currentPage == IPossiblePages.LOADER_PAGE || currentPage == IPossiblePages.LANDING_PAGE) {
            props.setGoHome(true);

            return;
        }
        dispatchCurrentPage({ type: IPossiblePages.LANDING_PAGE })
    }

    const checkWhetherGotMemberId =()=>{
        setSsoIABExitClicked(true)
        console.log("inside checkWhetherGotMemberId")
    }

    useEffect(()=>{
        console.log("useEffect ssoIABExitClicked")
        if( ssoIABExitClicked ){
            if(!props.externalSignIn.memberId){
                props.setGoHome(true);
            }
            console.log("ssoIABExitClicked", props.externalSignIn.memberId)
            setSsoIABExitClicked(false);
        }

    },[ssoIABExitClicked])

    const redirectForLoginIn = async (hideBrowserSession = false) => {
        console.log("The Know -> redirectForLoginIn")


        setErrorMsg("");

        await getTheKnowLoginUrl()
            .then((res) => {
                console.log("getTheKnowLoginUrl response is ", res)
                if (!(res && res.header && res.header.status && res.header.status.code == "SUCCESS")) {
                    setErrorMsg(res && res.header && res.header.status && res.header.status.msg)
                    throw { error: res };
                }

                if (!(res && res.payload && res.payload.cendynSSOLoginAuthUrl)) {
                    setErrorMsg("Login url seems to be empty")
                    throw { error: res };
                }

                // if (!(res && res.payload && res.payload.cendynSSOSignUpAuthUrl)) {
                //     setErrorMsg("Sign Up url seems to be empty")
                //     throw { error: res };
                // }

                console.log(props.currentWidgets, "props.currentWidgets.widgetType")

                let targetUrl;
                if(props.currentWidgets.widgetType=="Sign Up(The Know)"){
                    targetUrl = res.payload.cendynSSOSignUpAuthUrl || "https://virginhotels.com/the-know/register?loginUrl=#ENCODED_SSO_LOGIN_URL";
                    // targetUrl = String(targetUrl).replace("#ENCODED_SSO_LOGIN_URL",encodeURIComponent(res.payload.cendynSSOLoginAuthUrl))
                } else{
                    targetUrl = res.payload.cendynSSOLoginAuthUrl;
                    // targetUrl = `${targetUrl}&LoginUrl=${encodeURIComponent(encodeURIComponent(res.payload.cendynSSOLoginAuthUrl))}`
                }

                setOnSsoSuccessUrl(res.payload.onSsoSuccessUrl);

                let randNum = Math.floor(Math.random() * 100000) + 1;
                let statePrefix = !window.device ? "web_" : "native_";
                targetUrl = `${targetUrl}&state=${statePrefix}${randNum}`;

                console.log(targetUrl, "targeturl")

                inAppBrowser(targetUrl, { ...props, getExternalSignIn: () => { return props.externalSignIn } }, true, { displayName: "External Sign In", dontSetCurrentWidget: true , isTheKnowSsoLink:true , checkWhetherGotMemberId, meta: { loadInExternalBrowser: !window.device } }, hideBrowserSession == true ? true : false);
                if (!window.device) {
                    props.setGoHome(true);
                }
            })

            .catch((err) => {
                console.log("in catch of getTheKnowLoginUrl api call , error:", err)
                sendTheAnalytics("SSO Login Url Fetch", false, "Failed to fetch sso url")
                props.closeOrderPopUp(true,err && err.response && err.response.data && err.response.data.header && err.response.data.header.status && err.response.data.header.status.msg  || t('the_know.api_response.sso_url_fetch_failed'), "", true);

                signOutSSO();
                props.setGoHome(true)
            })
            .finally(() => {

                setErrorMsg("");
            })
    }

    const markVredAccountLinked = (token, memberId) => {
        props.setExternalSignIn("shouldMarkAccountLinkedManually",false)

        updateLinkedAccountInfo(token, memberId)
            .then((res) => {
                console.log("updateLinkedAccountInfo response is ", res)
                if (!(res && res.data && res.data.header && res.data.header.status && res.data.header.status.code == "SUCCESS")) {
                    throw { response: res };
                }

            })
            .catch(({ response = {} }) => {
                sendTheAnalytics("Mark Vred Account Linked", false, t('the_know.api_response.vred_account_linked_failed'))
                props.closeOrderPopUp(true, response && response.data && response.data.header && response.data.header.status && response.data.header.status.msg  || t('the_know.api_response.vred_account_linked_failed'), "", true);
          
                if (response.status == 403 || response.status == 400) {
                    console.log("access token expired/ incorrect")
                    // show session token expired, so re-login
                }
            })
                 
    }
 
    const getAccessToken = async (isRefreshingToken=false) => {
        console.log("inside getAccessToken")
        setErrorMsg("");

        // setAccessTokenExpired(true);
        try {
            const validateAccountResponse= JSON.parse(localStorage.getItem("theKnowUserInfo")) && JSON.parse(localStorage.getItem("theKnowUserInfo")).validateAccountResponse;
            if(!validateAccountResponse) throw {};

            let payload = validateAccountResponse.payload.accessTokenRequest.requestPayload;
            
            if(isRefreshingToken){
                payload = { ...payload, refresh_token: props.externalSignIn.refreshToken, grant_type: "refresh_token"};
            }else{
                payload = { ...payload, code: props.externalSignIn.code };
            }
            
            console.log(" payload", payload)

            let requestUri = validateAccountResponse.payload.accessTokenRequest.requestUrl;
            console.log(" requestUri", requestUri)

            await getVredAccessToken(requestUri, payload)
                .then((res) => {
                    if (res.access_token) {
                        // setAccessTokenExpired(false);

                        updateTheKnowTokens(res.access_token, res.refresh_token)
                        if (props.externalSignIn.shouldMarkAccountLinkedManually) markVredAccountLinked(res.access_token, props.externalSignIn.memberId)

                    } else {
                        console.log("failed to fetch token")
                        // show popup of error -> res.error || res.error_description|| "Failed to fetch access token"
                    }
                })
                .catch((err) => {
                    console.log("in catch of getAccessToken api call , error:", err)
                    if(isRefreshingToken) signOutSSO();

                    sendTheAnalytics("Get Virgin Access Token", false, "Failed to get virgin access token")
                    props.closeOrderPopUp(true, err && err.response && err.response.data && err.response.data.header && err.response.data.header.status && err.response.data.header.status.msg  || t('the_know.api_response.failed_fetch_vred_access_token'), "", true);
                })
                .finally(() => {

                    setErrorMsg("");
                })

        } catch (err) {
            console.log("catch :", JSON.stringify(err))
        }
    }


    const updateTheKnowTokens = (accessToken, refreshToken) => {
        let theKnowUserInfo = JSON.parse(localStorage.getItem("theKnowUserInfo")) || {};
        localStorage.setItem("theKnowUserInfo", JSON.stringify({ ...theKnowUserInfo, accessToken, refreshToken }))
        props.setExternalSignIn("accessToken", accessToken);
        props.setExternalSignIn("refreshToken", refreshToken);
    }

    const handleAccessTokenExpired = async (callback) => {

        
        // updateTheKnowTokens("");
        // props.setExternalSignIn("accessToken", "");
        // if(window.device){
        //     setAccessTokenExpired(true);
        //     redirectForLoginIn(true);
        // } else {
        //     props.closeOrderPopUp(true, "Access token got expired or invalid. Please re-login.", "", true)
        // }

        await getAccessToken(true)
    }


    const handleSignOut = () => {
        console.log("inside handleSignOut")
        localStorage.removeItem("theKnowUserInfo");

        props.setExternalSignIn("responseReceivedFromHostedScript","");
        props.setExternalSignIn("validateAccountResponse",{});
        props.setExternalSignIn("memberId","");
        props.setExternalSignIn("code","");
        props.setExternalSignIn("accessToken","");
        props.setExternalSignIn("shouldMarkAccountLinkedManually",false);
        props.setExternalSignIn("jwtIdToken","");

        props.setGoHome(true);
    }

    const getMyStayData = async (refreshData)=> {
        if( !refreshData && ( apiData.STAYS.data || apiData.STAYS.isFetching || apiData.STAYS.errorMsg ) ) return;

        dispatchApiData({type:IApiData.STAYS_ENABLE_FETCHING});

        const memberId= props.externalSignIn.memberId;

        await getVredStayData(memberId)
        .then((res)=>{
            console.log("getVredStayData response is ", res)
             if(!(res && res.data && res.data.header && res.data.header.status && res.data.header.status.code == "SUCCESS" )){
                throw {response:res};
             }

             if(!(res.data.payload)){
                throw {response:res};
             } 
             let stayPayload= res.data.payload;
             stayPayload.stay= res.data.payload.stay && res.data.payload.stay.sort((a,b)=> new Date(a.arrival).getTime() - new Date(b.arrival).getTime() )
             
             stayPayload.stay =  stayPayload.stay.filter(stay=> stay && stay.reservation_status_description && (stay.reservation_status_description!=stayReservationPossibleStatus.CANCELLED) && stay.pms_property_code != "LEAGS" );

             dispatchApiData({type:IApiData.STAYS_DATA_SUCCESS, payload: stayPayload })
                   

        })
        .catch(({response={}})=>{
            console.log("catch in stay api", response)
            sendTheAnalytics("Reservation Stay Fetch", false, t("the_know.api_response.stay_failed"))
            props.closeOrderPopUp(true,  response && response.data && response.data.header && response.data.header.status && response.data.header.status.msg  ||  t("the_know.api_response.stay_failed"), "", true);
               
            dispatchApiData({type:IApiData.STAYS_DATA_FAILURE, payload: (response && response.data && response.data.header   && response.data.header.status  && response.data.header.status.msg ) || t("the_know.api_response.stay_failed") })
        })

        
    }

    // const handleCendynLoginCompleted = () =>{
    //     console.log("handleCendynLoginCompleted, started")

    //     inAppBrowser(onSsoSuccessUrl || "https://virginhotels.com/login",props,true, {dontSetCurrentWidget: true}, true)

    // }
    

    useEffect(() => {
        console.log("useEffect -> props.externalSignIn")

        const handleNewResponseFromInAppBrowser = async () => {
            if (props.externalSignIn.responseReceivedFromHostedScript != "") {
                const responseCode = props.externalSignIn.responseReceivedFromHostedScript;
                props.setExternalSignIn("responseReceivedFromHostedScript", "")
                console.log("responseReceivedFromHostedScript", responseCode)

                switch (responseCode) {
                    case TheKnowResponseCodeFromHostedScriptForInAppBrowser.VALIDATE_API_FAIL:
                        props.closeOrderPopUp(true, "We observed issue while validating account.", "", true)
                        return;
                    case TheKnowResponseCodeFromHostedScriptForInAppBrowser.EMPTY_REDIRECT_URI_FOR_VRED:
                        props.closeOrderPopUp(true, "Something went wrong.", "", true);
                        return;
                    case TheKnowResponseCodeFromHostedScriptForInAppBrowser.ABORT_TO_CONNECT_VRED:
                        props.closeOrderPopUp(true, "Connection process cancelled.", "", true);
                        return;
                    case TheKnowResponseCodeFromHostedScriptForInAppBrowser.UNSUCCESSFUL_CONNECTION_TO_VRED:
                        props.closeOrderPopUp(true, "Unable to connect to Virgin Red.", "", true);
                        return;
                    case TheKnowResponseCodeFromHostedScriptForInAppBrowser.RECEIVED_CODE_FOR_VRED:
                        setTimeout(async () => {
                            await getAccessToken(); 
                            userAutoLoginUsingTheKnow(props, true);

                        }, 1000)
                        return;
                    case TheKnowResponseCodeFromHostedScriptForInAppBrowser.SUCCESSFUL_LOGOUT_TO_VRED:
                        handleSignOut();
                        return;
                    case TheKnowResponseCodeFromHostedScriptForInAppBrowser.GOT_MEMBER_ID:
                        const label = getDefaultAnalyticsLabel({
                            appVersion: props.installedAppVersion
                                ? `${props.installedAppVersion}(${props.installedAppBuildNo})`
                                : ""
                        });

                            props.sendAnalytics(
                                props.guestDetail,
                                "LOYALTY_SIGN_IN",
                                "THE KNOW LOGIN - SUCCESS",
                                {
                                    ...label,
                                   "pageName":"THE KNOW",
                                   "layoutTab": props.currentHomePage && props.currentHomePage.tabName,
                                    timestamp: new Date().toISOString(),
                                    memberId: props.externalSignIn.memberId
                                },
                                0,
                                props.guestIsLoggedIn,
                            );
                        return;
                    default:
                        return;
                }
            }

        }

        handleNewResponseFromInAppBrowser();

    }, [props.externalSignIn.responseReceivedFromHostedScript])


    useEffect(()=>{
        if(props.externalSignIn.validateAccountResponse  && Object.keys(props.externalSignIn.validateAccountResponse).length ){
            let theKnowUserInfo = JSON.parse(localStorage.getItem("theKnowUserInfo")) || {};
            localStorage.setItem("theKnowUserInfo", JSON.stringify({ ...theKnowUserInfo, validateAccountResponse: props.externalSignIn.validateAccountResponse }))
        }
    },[props.externalSignIn.validateAccountResponse])

    useEffect(() => {
        if (props.externalSignIn.memberId) {
            if (props.currentHomePage.uniqueKey == "mytrips") {
                dispatchCurrentPage({ type: IPossiblePages.MY_STAY_PAGE });
                return;
            }
            dispatchCurrentPage({ type: IPossiblePages.LANDING_PAGE });
        }
    }, [props.externalSignIn.memberId, props.currentHomePage.uniqueKey])

    useEffect(()=>{
        if( currentPage === IPossiblePages.LOADER_PAGE ){
            props.setLoader(true, "Loading...", true) 
        } else {
            props.setLoader(false) 
        }
    },[currentPage])
     


    useEffect(() => {
        console.log("/theKnow useEffect into")
        if(sessionStorage.getItem("redirectInfo")) return ;
        if (!props.externalSignIn.memberId && ( !localStorage.getItem("theKnowUserInfo") || !JSON.parse(localStorage.getItem("theKnowUserInfo")).memberId )) {
            console.log("startSSOflow")
            redirectForLoginIn();
        }

        return ()=>{
            props.setLoader(false);
        }
    }, [])


    useEffect(() => {

        if(sessionStorage.getItem("redirectInfo")) return;
        
        if ([...theKnowKeys, ...myTripsKeys].includes(props.currentHomePage.uniqueKey)) {
            props.currentWidget({});
        } else {
            let theknowTab = props.footerTabList && props.footerTabList.find((item) => {
                return theKnowKeys.includes(item.uniqueKey.toLowerCase())
            });

            if (!theknowTab) {
                theknowTab = props.footerTabList && props.footerTabList.find((item) => {
                    return myTripsKeys.includes(item.uniqueKey.toLowerCase())
                });
            }

            if (theknowTab) {
                props.setCurrentHomePage(theknowTab);

                console.log("this.props.footerTabList", theknowTab)
                props.widgetList.map((item) => {
                    if (item.uniqueKey === theknowTab.uniqueKey || item.uniqueKey === theknowTab.tabName.replace(/ /g, '').toLowerCase()) {
                        props.setCurrentTabNavItemList();
                        props.setCurrentTabNavItemList(item.widgets);
                    }
                })
                props.currentWidget({});
            }
        }

    }, [])


    return (
        <>

            <MyContext.Provider value={{ currentPage, dispatchCurrentPage, IPossiblePages, apiData, dispatchApiData, IApiData, accessTokenExpired, handleAccessTokenExpired, getMyStayData }}>

                <div class="the-know">

                    {
                        props.currentWidgetObj.widgetType &&
                        <header className="inner-pages w-footer subpages">
                            <a className="button-back" onClick={() => handleGoBack()}></a>
                            <div className="heading align-center">
                                <div class="splash-brand">
                                    <img src={`${CMSPath}${props.logo}`} />
                                </div>
                            </div>
                        </header>
                    }
                    {
                         
                            <>
                                {currentPage === IPossiblePages.LANDING_PAGE && (
                                    <LandingPage signOutSSO={signOutSSO} redirectForLoginIn={redirectForLoginIn} sendTheAnalytics = {sendTheAnalytics}/>
                                )}
                                {currentPage === IPossiblePages.SETTING_PAGE && (
                                    <SettingPage signOutSSO={signOutSSO} sendTheAnalytics = {sendTheAnalytics}/>
                                )}
                                {currentPage === IPossiblePages.MY_STAY_PAGE && (
                                    <MyStayPage sendTheAnalytics = {sendTheAnalytics} />
                                )}
                                {currentPage === IPossiblePages.POINTS_PAGE && (
                                    <PointsPage sendTheAnalytics = {sendTheAnalytics}/>
                                )}
                            </>
                        }
                </div>
            </MyContext.Provider>
        </>
    )
}

const getTabs = (duration) => {
    if (duration && duration.tabDetails && duration.tabDetails.length > 0) {
        return duration.tabDetails
    } else { return false }
}

const mapStateToProps = (state) => {
    return {
        externalSignIn: state.store2.externalSignIn,
        selectedHomePage: state.store2.currentHomePage,
        showNewHeader: state.store2.showNewHeader,
        currentWidgetObj: state.store.sideNavBar.currentWidget,
        widgetList: state.store2.sideNavBar.widgetList,
        notifications: state.store.home.gJnotifications,
        profile: state.store.home.currentDuration.brandingInfo.app ?
            state.store.home.currentDuration.brandingInfo.app.profileWidget : {},
        logo: state.store.home.currentDuration.brandingInfo ?
            state.store.home.currentDuration.brandingInfo.hotelLogoImageUrl : "",
        bgImage: state.store.home.currentDuration.launcherBgImageUrl,
        guestName: state.store.home.guestDetails ?
            state.store.home.guestDetails.guestName : null,
        selfieVideo: state.store2.selfieVideo,
        menuColor: state.store.home.MenuColor,
        currentHomePageBeforeNotificationTab: state.store2.currentHomePageBeforeNotificationTab,
        currentHomePage: state.store2.currentHomePage,
        selectedHomePage: state.store2.currentHomePage,
        menuColor: state.store.home.MenuColor,
        preCheckInBookingDueIn: state.store2.preCheckInBookingDueIn,
        widgetList: state.store2.sideNavBar.widgetList,
        footerTabList: getTabs(state.store.home.currentDuration),
        notifications: state.store.home.gJnotifications,
        externalSignIn: state.store2.externalSignIn,
        installedAppVersion: state.store.installedAppVersion,
        logo: state.store.home.currentDuration.brandingInfo ?
            state.store.home.currentDuration.brandingInfo.hotelLogoImageUrl : "",
        currentHomePage: state.store2.currentHomePage,
        currentWidgetObj: state.store.sideNavBar.currentWidget,
        guestDetail: state.store.home.guestDetails,
        guestIsLoggedIn: state.store2.guestIsLoggedIn,
        currentWidgets: state.store.sideNavBar.currentWidget,
        serverTimeDate: state.store.home.serverTimeDate.date,
        dateFormat: state.store.home.clientConfig.extraConfigParam
            ? state.store.home.clientConfig.extraConfigParam.DATE_FORMAT
            : "",
        menuColor: state.store.home.MenuColor,
        currencyCode: state.store.home.clientConfig.currencyDetails
            ? state.store.home.clientConfig.currencyDetails.code
            : "",
        allowWalkInGuestRestaurantBooking: state.store.home.clientConfig.webAppWidgetsInfo && state.store.home.clientConfig.webAppWidgetsInfo.appConfigs && state.store.home.clientConfig.webAppWidgetsInfo.appConfigs.restaurantReservationConfigs ? state.store.home.clientConfig.webAppWidgetsInfo.appConfigs.restaurantReservationConfigs.allowWalkInGuestRestaurantBooking : false,
        installedAppBuildNo: state.store.installedAppBuildNo,
    }
}
export default connect(mapStateToProps, {
    setGoHome, setShowCustomPopup, closeOrderPopUp, sendAnalytics, currentWidget, popupOpenClose, setExternalSignIn,
    setCurrentHomePage,
        currentWidget,
        setCurrentHomePageBeforeNotificationTab,
        setCurrentTabNavItemList,
        setLoader,
        setShowAutoLoginPopup,

})(
    withTranslation("translations")(TheKnow)
);